export const AUTH_REDIRECT_QUERY_PARAM = 'redirectUrl'
export const REQUESTED_PATH_HEADER_NAME = 'x-skop-return-to'

export const sanitizeRedirectPath = (
  input: string | null | undefined,
  fallback: string = '/',
): string => {
  if (typeof input !== 'string') return fallback

  const suffixStart = input.search(/[?#]/)
  const rawPath = suffixStart === -1 ? input : input.slice(0, suffixStart)
  const rawSuffix = suffixStart === -1 ? '' : input.slice(suffixStart)

  // Reject encoded slash/backslash sequences in the pathname before decoding.
  if (/%2f/i.test(rawPath) || /%5c/i.test(rawPath)) return fallback

  let decodedPath: string
  try {
    decodedPath = decodeURIComponent(rawPath)
    if (rawSuffix) {
      decodeURIComponent(rawSuffix)
    }
  } catch {
    return fallback
  }

  if (!decodedPath.startsWith('/')) return fallback

  // Reject protocol-relative URLs (//host) but allow multiple leading slashes for normalization.
  if (decodedPath.startsWith('/\\') || decodedPath.includes('\\')) {
    return fallback
  }
  if (/^\/\/[^/]/.test(decodedPath)) return fallback

  // Normalize by segments; reject '.' and '..' segments.
  const segments = decodedPath.split('/').filter(Boolean)
  for (const segment of segments) {
    if (segment === '.' || segment === '..') return fallback
  }

  const normalized = `/${segments.join('/')}`

  // Ensure single leading slash (should always hold after normalization).
  if (normalized.startsWith('//')) return fallback

  return `${normalized}${rawSuffix}`
}
